import React, { useEffect } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const CopyToClipboardTool = ({ data }: any): JSX.Element => {

   const toolTipStatus = { copy: "copy content", copied: "copied" };
   const [copyContent, setCopyContent] = React.useState<string>(toolTipStatus.copy);

   const onCopytoClipBoard = () => {
      setCopyContent(toolTipStatus.copied);
   }

   useEffect(
      () => {
         if (data) {
            setCopyContent(toolTipStatus.copy);
         }
      },
      [data],
   );

   return (
      <CopyToClipboard text={data}
         onCopy={onCopytoClipBoard}>
         <Tooltip title={copyContent} placement="bottom">
             <button className="btn bg-white px-0">[c]</button>
         </Tooltip>
      </CopyToClipboard>
   )
}

export default CopyToClipboardTool;